import { UtmSourceValues } from 'root-constants'

const REQUIRED_CAMPAIGN_VALUES = [
  UtmSourceValues.RETENO,
  UtmSourceValues.WOOFZWEBSITE,
  UtmSourceValues.WOOFZWEBSITE_ES,
] as const

export const getCampaignId = (
  utmTags: Record<string, string>,
): string | null => {
  const utmSource = utmTags?.utm_source
  const campaignId = utmTags?.utm_campaign

  if (!utmSource || !campaignId) return null

  const isCampaignIdRequired = REQUIRED_CAMPAIGN_VALUES.includes(
    utmSource as typeof REQUIRED_CAMPAIGN_VALUES[number],
  )

  return isCampaignIdRequired ? campaignId : null
}
